
<div class="block">
    <div class="required">
        <label>{{ 'Components.EnterPhone.PhoneHeaderText' | translate }}</label>
    </div>

    <app-phone-input [phoneValueWithRegion]="phoneValueWithRegion"
                     (phoneValueWithRegionChange)="phoneValueWithRegionChange.emit($event)">
    </app-phone-input>

    <div class="text-muted">{{ 'Components.EnterPhone.PhoneDescriptionText' | translate }}</div>

</div>

<div class="block">
    <app-captcha #captchaComponent></app-captcha>
    <div class="form-group mt-3">
        <label for="captchaCode">{{ 'Common.CaptchaText' | translate }}</label>
        <input class="form-control"
               id="captchaCode"
               name="captchaCode"
               type="text"
               autocomplete="off"
               placeholder="{{ 'Common.CaptchaText' | translate }}"
               [(ngModel)]="captchaCode">
    </div>
</div>

<div class="btn-group">
    <button class="btn btn-primary"
            type="submit"
            [disabled]="submitProcessing"
            (click)="submitButtonClick($event)">
        {{submitButtonText}}
    </button>
</div>

<span *ngIf="errorText"
      class="text-danger error">
    {{errorText}}
</span>
